import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import { Editor, Path } from 'slate';
var BOLDITALICREG = /\*\*\*(\S+)\*\*\*|\_\_\_(\S+)\_\_\_|\*\_\_(\S+)\_\_\*|\_\*\*(\S+)\*\*\_|\_\_\*(\S+)\*\_\_|\*\*\_(\S+)_\*\*/;
var BOLDREG = /\*\*(\S+)\*\*|\_\_(\S+)\_\_/;
var ITALICREG = /\*(\S+)\*|_(\S+)_/;
var CODEREG = /\`(\S+)\`/;
var TextUtils = /*#__PURE__*/_createClass(function TextUtils(_editor) {
  var _this = this;
  _classCallCheck(this, TextUtils);
  this.getTextInfoBeforeSelection = function () {
    var editor = _this.editor;
    var selection = _this.editor.selection;
    var anchor = selection.anchor;
    var _Editor$nodes = Editor.nodes(editor, {
        match: 'block'
      }),
      _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
      block = _Editor$nodes2[0];
    var path = block ? block[1] : [];
    var start = Editor.start(editor, path);
    var range = {
      anchor: anchor,
      focus: start
    };
    var beforeText = Editor.text(editor, range);
    return {
      range: range,
      beforeText: beforeText,
      block: block
    };
  };
  this.setTextMarkByShortCut = function (exec, command) {
    var editor = _this.editor;
    var selection = editor.selection;
    var _Editor$node = Editor.node(editor, selection),
      _Editor$node2 = _slicedToArray(_Editor$node, 2),
      textNode = _Editor$node2[0],
      textPath = _Editor$node2[1];
    var text = textNode.text;
    var offset = selection.anchor.offset;
    var lastChart = text[offset - 1];
    var marks, markText, startOffset;
    var matched;
    if (lastChart === '_' || lastChart === '`' || lastChart === '*') {
      if (matched = text.match(BOLDITALICREG)) {
        startOffset = matched.index;
        marks = {
          BOLD: true,
          ITALIC: true
        };
      } else if (matched = text.match(BOLDREG)) {
        startOffset = matched.index;
        marks = {
          BOLD: true
        };
      } else if (matched = text.match(ITALICREG)) {
        startOffset = matched.index;
        marks = {
          ITALIC: true
        };
      } else if (matched = text.match(CODEREG)) {
        startOffset = matched.index;
        marks = {
          CODE: true
        };
      }
      if (matched) {
        for (var index = 1; index < matched.length; index++) {
          if (matched[index]) {
            markText = matched[index];
            break;
          }
        }
        marks = Object.assign({
          BOLD: false,
          ITALIC: false,
          CODE: false
        }, marks);
        Editor.select(editor, {
          anchor: {
            path: textPath,
            offset: startOffset
          },
          focus: {
            path: textPath,
            offset: offset
          }
        });
        Editor.delete(editor, editor.selection);
        // insert a space before mark
        Editor.insertText(editor, ' ');
        Editor.insertNodes(editor, [_objectSpread({
          text: markText
        }, marks), {
          text: ' '
        }]);
        var selectedPath = Path.next(Path.next(textPath));
        // select the next empty text node to escape the mark
        Editor.select(editor, selectedPath);
        Editor.collapse(editor, {
          edge: 'end'
        });
        return;
      }
    }
    exec(command);
  };
  this.editor = _editor;
}

// Get text related variables before current selection
// block: Parent of current text node
// range: From start of block to current selection
// beforeText: The text of block from start to selection
);

export default TextUtils;